import { Action } from "./action";
import { ActionBase } from "./actionBase";
import { CanceledAction } from "./canceledAction";
import { DiscontinuedAction } from "./discontinuedAction";
import { OrderSignatureRequests } from "./orderSignatureRequests";

export interface OrderBase {
  externalPatientChartId?: number;
  patientName?: string;
  orderType: string;
  tenantId?: number;
  nameDescription: string;
  createdAction?: ActionBase;
  modifiedAction?: ActionBase;
  discontinuedAction?: DiscontinuedAction;
  canceledAction?: CanceledAction;
  startDate: string;
  startDateDisplay?: string;
  discontinueDate?: string;
  discontinueDateDisplay?: string;
  categories?: Set<string>;
  categoryOtherDescription?: string;
  teamName?: string;
  teamId?: number;
  teamQbosId?: number;
  patientChartId?: number;
  orderId?: string;
  history?: Array<Action>;
  createdDatetime?: string;
  updatedDatetime?: string;
  createdById?: number;
  updatedById?: number;
  migrationId?: number;
  signatureRequests?: OrderSignatureRequests;
}

export namespace OrderBase {
  export function orderSubtypeDisplay(orderSubtype: string) {
    switch (orderSubtype) {
      case "ERX":
        return "eRx";
      default:
        return orderSubtype;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/order-management/orderBase.ts